import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import store from "./redux/store";
import WebFont from "webfontloader";
import "./static/assets/fonts/Archia-Regular.otf";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

WebFont.load({
  custom: {
    families: ["Open Sans", "sans-serif", "Muli"],
  },
});

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
